import React, {useState, useEffect} from 'react';
import {Checkbox} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {connectWithCore} from 'framework/hocs';
import {Button} from 'semantic-ui-react';
import ReactHtmlParser from 'react-html-parser';
import _ from 'lodash';
import DATA_FILTERS from 'go/components/common/dataFilters';

export const DynamicMultiCheckboxSelect = ({
  id,
  title,
  selectableOptions,
  noOptionsMessage,
  readOnly,
  optionNameField,
  optionIdField,
  validationId,
  entityDataPath,
  entityType,
  saveEntityData,
  validationErrors,
  validationDirtyMap,
  defaultCheckAll,
  data = [],
  prevReviewedDate,
  filterFunc,
  skipReducerOnLoad = false,
  saveSessionOnly,
  saveEntitySessionData,
  hasCheckAll = true,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(data);
  const [initialData] = useState(data);

  const setChanged = () => {
    _.isEqual(data, initialData)
      ? saveEntitySessionData(`context.${id}.changed`, true)
      : saveEntitySessionData(`context.${id}.changed`, false);
  };

  useEffect(() => {
    if (!readOnly && defaultCheckAll) {
      handleNewlyAddedOptionsSelection();
    }
  }, [defaultCheckAll, readOnly]);

  useEffect(() => {
    if (!_.isEqual(selectedOptions, data)) {
      setSelectedOptions(data);
    }
  }, [data]);

  const handleNewlyAddedOptionsSelection = () => {
    if (!_.isEmpty(selectableOptions) && prevReviewedDate === undefined) {
      handleSelectAll();
    } else if (filterFunc) {
      let newSelectedOptions = DATA_FILTERS[filterFunc]({
        selectableOptions,
        prevReviewedDate,
        optionIdField,
        selectedOptions,
      });
      setSelectedOptions(newSelectedOptions);
      saveEntityData(entityDataPath, entityType, newSelectedOptions, validationId, {
        onLoad: skipReducerOnLoad,
      });
    }
  };

  const validationErrorsArray =
    _.isEmpty(validationErrors) || _.isArray(validationErrors)
      ? validationErrors
      : [validationErrors];
  const firstError = _.find(validationErrorsArray, (err) => !err.isValid) || false;
  const errorMessage = firstError ? firstError.message : false;

  const displayError = firstError && validationDirtyMap.dirty;
  const errorMessages = errorMessage;

  const handleChange = (value) => {
    setChanged();
    let newSelectedOptions = [...selectedOptions];
    if (_.includes(newSelectedOptions, value)) {
      newSelectedOptions = _.remove(newSelectedOptions, (item) => item !== value);
    } else {
      newSelectedOptions = [...newSelectedOptions, value];
    }
    setSelectedOptions(newSelectedOptions);
    handleSave(newSelectedOptions);
  };

  const handleSelectAll = () => {
    let newSelectedOptions = new Array();
    _.map(selectableOptions, (opt, idx) => {
      newSelectedOptions.push(_.get(opt, optionIdField));
    });
    setSelectedOptions(newSelectedOptions);
    handleSave(newSelectedOptions);
  };

  const handleUnSelectAll = () => {
    const newSelectedOptions = [];
    setSelectedOptions(newSelectedOptions);
    handleSave(newSelectedOptions);
  };

  const handleSave = (newSelectedOptions) => {
    if (saveSessionOnly === true) {
      saveEntitySessionData(
        entityDataPath,
        newSelectedOptions,
        validationId || entityDataPath
      );
    } else {
      saveEntityData(entityDataPath, entityType, newSelectedOptions, validationId);
    }
  };
  const renderCheckAll = () => {
    if (!readOnly && _.size(selectedOptions) < _.size(selectableOptions)) {
      return (
        <Button
          id="selectAll"
          primary
          onClick={() => {
            setChanged();
            handleSelectAll();
          }}
        >
          Check All
        </Button>
      );
    } else {
      return null;
    }
  };

  const renderUncheckAll = () => {
    if (!readOnly && _.size(selectedOptions) > 0) {
      return (
        <Button
          id="unSelectAll"
          primary
          onClick={() => {
            setChanged();
            handleUnSelectAll();
          }}
        >
          Uncheck All
        </Button>
      );
    } else {
      return null;
    }
  };

  if (_.isNull(selectableOptions) || _.isEmpty(selectableOptions)) {
    return <h3>{noOptionsMessage}</h3>;
  } else {
    return (
      <React.Fragment>
        <div className={`formControl ${displayError ? 'errorBorderLine' : ''}`}>
          <div className="questionText">{ReactHtmlParser(title)}</div>
          <ul className="checkboxItemList">
            {_.map(selectableOptions, (opt, idx) => {
              const optionValue = _.get(opt, optionIdField);
              const optionName = _.get(opt, optionNameField);

              if (!optionName) return null;

              return (
                <li key={idx}>
                  <Checkbox
                    disabled={readOnly}
                    id={`checkbox_${_.get(opt, optionIdField, idx)}`}
                    checked={_.includes(selectedOptions, _.get(opt, optionIdField))}
                    label={optionName}
                    name={`${entityDataPath}`}
                    handleChange={() => handleChange(optionValue)}
                  />
                </li>
              );
            })}
          </ul>
          {displayError && <div className="errorMessages">{errorMessages}</div>}
          {hasCheckAll && renderCheckAll()}
          {renderUncheckAll()}
        </div>
      </React.Fragment>
    );
  }
};

export default connectWithCore(DynamicMultiCheckboxSelect);
